import axios from 'services/axios'
import {
  API_TICKET_OPEN_LIST,
  API_TICKET_CLOSED_LIST,
  API_TICKET_CATEGORY_LIST,
  API_TICKET_UPLOAD_FILE,
  API_TICKET_CREATE,
  API_TICKET_INFO,
  API_TICKET_DOWNLOAD_ATTACH,
  API_TICKET_TAG_AS_RESOLVED,
} from 'constants/endpoints'

// Models
import TicketInfoModel from 'models/Ticket'

/**
 * Get list open tickets
 *
 * @param {String} url
 * @returns {Object}
 */
export const getListOpenTicket = async (lastId) => {
  try {
    const { data, last } = await axios.get(API_TICKET_OPEN_LIST, {
      params: {
        size: 10,
        'last-index': lastId,
      },
    })

    const list = data.map((x) => {
      return new TicketInfoModel(x)
    })

    return { list, last }
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Check if has closed ticket
 *
 * @returns {Boolean}
 */
export const hasClosedTickets = async () => {
  try {
    const { data } = await axios.post(API_TICKET_CLOSED_LIST, {
      page: 1,
      limit: 10,
      search: '',
    })

    return data.length > 0
  } catch (error) {
    return false
  }
}

/**
 * Get ticket category list
 *
 * @returns {Object}
 */
export const getTicketCategoryList = async () => {
  try {
    const { data } = await axios.get(API_TICKET_CATEGORY_LIST)

    const typeList = []
    const categoryList = Object.keys(data).map((x) => {
      return {
        label: x,
        value: x,
      }
    })

    Object.keys(data).forEach((key) => {
      data[key].forEach((item) => {
        typeList.push({
          typeId: item.id,
          typeName: item.type,
          category: key,
          toolTip: item.toolTip,
        })
      })
    })

    return { categoryList, typeList }
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Upload file
 *
 * @param {File} file
 * @returns {Object}
 */
export const uploadFile = async ({ file, onUploadProgress }) => {
  try {
    const { data } = await axios.post(
      API_TICKET_UPLOAD_FILE,
      {
        file,
      },
      {
        onUploadProgress,
      }
    )

    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Create ticket
 *
 * @param {Object} payload
 */
export const createTicket = async (payload) => {
  try {
    await axios.post(API_TICKET_CREATE, payload)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get ticket info
 *
 * @param {Object} { id, notificationId }
 * @returns {Object}
 */
export const getTicketInfo = async ({ id, notificationId }) => {
  try {
    const { data } = await axios.get(API_TICKET_INFO, {
      params: { id, notifiId: notificationId },
    })
    return new TicketInfoModel(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Download file attach
 *
 * @param {String} fileName
 * @param {Number} id
 * @return {Object}
 */
export const downloadTicketAttachment = async ({ name, id }) => {
  try {
    await axios.get(API_TICKET_DOWNLOAD_ATTACH, {
      params: {
        ticketId: id,
        fileName: name,
      },
      downloadFile: true,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Tag as resolved
 *
 * @param {Number} id
 *
 */
export const tagTicketAsResolved = async (id) => {
  try {
    await axios.put(API_TICKET_TAG_AS_RESOLVED, {
      ticketingId: id,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}
